module.exports = __webpack_public_path__ + "static/img/2002.398b00a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2002.jpg
// module id = 293
// module chunks = 0